import "./styles/OnBoardingButton.css";

export default function OnBoardingButton({ children, className = '', isActive = false, onClick, fullWidth = false  }) {

  const getClasses = () => {
    let classes = "";
    if(isActive) {
      classes = " active";
    }
    if(fullWidth) {
      classes += " w-full";
    }
    return classes;
  };

  return (        
    <>
      <button className={`onboarding__button ${className} ${getClasses()}`} onClick={onClick}> 
        {children}
      </button>
    </>);
}